import { useEffect, useState, type FormEvent } from 'react';
import { supabase } from '../lib/supabase';
import type { SiteConfig } from '../lib/types';
import PageHeader from '../components/PageHeader';

export default function CommunitySiteConfigPage() {
  const [foundationIntro, setFoundationIntro] = useState('');
  const [communityIntro, setCommunityIntro] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [savedAt, setSavedAt] = useState<string | null>(null);

  useEffect(() => {
    void load();
  }, []);

  const load = async () => {
    setLoading(true);
    setError(null);
    const { data, error: err } = await supabase
      .from('site_config')
      .select('*')
      .eq('id', 1)
      .maybeSingle();
    if (err) {
      setError(err.message);
    } else if (data) {
      const cfg = data as SiteConfig;
      setFoundationIntro(cfg.foundation_intro);
      setCommunityIntro(cfg.community_intro);
      setSavedAt(cfg.updated_at);
    }
    setLoading(false);
  };

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    const { data, error: err } = await supabase
      .from('site_config')
      .update({
        foundation_intro: foundationIntro,
        community_intro: communityIntro,
        updated_at: new Date().toISOString(),
      })
      .eq('id', 1)
      .select()
      .single();
    setSaving(false);
    if (err) {
      setError(err.message);
      return;
    }
    setSavedAt((data as SiteConfig).updated_at);
  };

  return (
    <>
      <PageHeader
        eyebrow="مجتمع مرسال"
        title="النصوص التعريفية"
        subtitle="النصوص اللي بتظهر في تاب مجتمع مرسال في التطبيق (المؤسسة + مجتمع مرسال)"
      />

      {error && <div className="error-inline">{error}</div>}

      {loading ? (
        <div className="empty">جاري التحميل...</div>
      ) : (
        <form className="card" onSubmit={submit}>
          <div className="field">
            <label>تعريف مؤسسة مرسال</label>
            <textarea
              rows={6}
              value={foundationIntro}
              onChange={(e) => setFoundationIntro(e.target.value)}
              required
            />
          </div>

          <div className="field">
            <label>تعريف مجتمع مرسال</label>
            <textarea
              rows={5}
              value={communityIntro}
              onChange={(e) => setCommunityIntro(e.target.value)}
              required
            />
          </div>

          <div className="modal-actions">
            {savedAt && (
              <span style={{ color: 'var(--text-secondary)', fontSize: 13 }}>
                آخر تحديث: {new Date(savedAt).toLocaleString('ar-EG', { timeZone: 'Africa/Cairo' })}
              </span>
            )}
            <button type="submit" className="btn" disabled={saving}>
              {saving ? 'جاري الحفظ...' : 'حفظ التغييرات'}
            </button>
          </div>
        </form>
      )}
    </>
  );
}
